import { logger } from '../utils'

import AccountManager from '../managers/account'
import SettingsManager from '../managers/settings'

import {
  ACCOUNT_AUTHORIZED,
  ACCOUNT_LOGOUT,
  ACCOUNT_RESOLVING,
  ACCOUNT_UPDATE,
  ACCOUNT_VERIFICATION_UPDATE,
  BESPOKE_MARKET_UPDATE,
  BETS_COUNT_UPDATE,
  BONUS_ACTIVATE,
  BONUS_DEACTIVATE,
  BONUS_ELIGIBLE,
  BONUS_STATUS,
  CONNECTION_UPDATE,
  PREFERENCES_UPDATE,
  SET_BETSLIP,
  SET_BETSLIP_MODE,
  SET_LAYOUT,
  SET_LIVE_CHAT,
  SET_MAIN_MENU,
  SET_MOBILE_DEVICE,
  SET_SIDEBAR_LEFT,
  SET_SIDEBAR_RIGHT,
  WALLET_UPDATE
} from '../actions'

import events from './events'
import ApiManager from '../api/request'
import Bus from './index'

/*
  Method for connecting system lifecycle methods to the bus internal events
*/
export default function connect (bus) {
  bus.on(events.socket.open, ({ connectionId }) => {
    bus.invoke({
      type: CONNECTION_UPDATE,
      payload: {
        id: connectionId,
        connected: true
      }
    })
  })

  bus.on(events.socket.closed, () => {
    bus.invoke({
      type: CONNECTION_UPDATE,
      payload: {
        connected: false
      }
    })
  })

  /*
    Authorication and resolving account handlers
  */

  // bus.on('betslip:main', action => {
  //   logger.debug('[betslip:main]', '💎', 'action', action)
  // })

  bus.on(events.auth.login, (profile) => {
    // Storing account data in app
    AccountManager.storeAccountData(profile)
    // Loading client preferences
    AccountManager.loadClientPreferences()

    try {
      const profileLang = profile.client.language
      const {
        lang
      } = SettingsManager.getSettings()

      // If users language differs from currently selected -
      // switch to user profile language
      if (profileLang && (profileLang !== lang)) {
        SettingsManager.updateSettings({
          lang: profileLang
        })
      }
    } catch (error) {
      logger.debug('[app] unable to verify profile language', error)
    }

    bus.invoke({
      type: ACCOUNT_AUTHORIZED,
      payload: profile
    })
  })

  bus.on(events.auth.resolved, (profile) => {
    // Storing account data in app
    AccountManager.storeAccountData(profile)
    // Loading client preferences
    AccountManager.loadClientPreferences()

    bus.invoke({
      type: ACCOUNT_AUTHORIZED,
      payload: profile
    })
  })

  bus.on(events.auth.resolving, () => {
    logger.debug('[app] resolving authentication')

    bus.invoke({
      type: ACCOUNT_RESOLVING
    })
  })

  bus.on(events.auth.unresolved, () => {
    // Logging auth resolve error
    logger.debug('[app] authentication unresolved')

    bus.invoke({
      type: ACCOUNT_LOGOUT
    })
  })

  /*
    This handler completely removes all authorization topics
    Stored and registered
    Dispatching action to UI on logout
  */
  bus.on(events.auth.logout, () => {
    AccountManager.logout()
      .finally(() => {
        Bus.emit(Bus.events.auth.logoutSuccess)
        bus.invoke({
          type: ACCOUNT_LOGOUT
        })
        // This must be the final step because the preceding tasks require the token
        ApiManager.setAuthorizationToken(null)
        logger.debug('AuthService.logout success.')
      })
  })

  /*
    Dispatching logout action once received unauthorized event
  */
  bus.on(events.auth.unauthorized, () => {
    // If there is no token, ignore this request because we're not authenticated
    const token = ApiManager.getAuthorizationToken()
    if (!token) {
      return
    }
    bus.emit(events.auth.logout)
  })

  /*
    Profile updates handlers
    Account and wallet data
  */
  bus.on(events.profile.clientVerification, payload => {
    bus.invoke({
      type: ACCOUNT_VERIFICATION_UPDATE,
      payload
    })
  })

  bus.on(events.profile.preferencesUpdate, payload => {
    bus.invoke({
      type: PREFERENCES_UPDATE,
      payload
    })
  })

  bus.on(events.profile.balanceUpdate, ({ data }) => {
    bus.invoke({
      type: WALLET_UPDATE,
      payload: data
    })
  })

  bus.on(events.profile.bonusActivate, ({ data }) => {
    bus.invoke({
      type: BONUS_ACTIVATE,
      payload: data
    })
  })

  bus.on(events.profile.bonusDeactivate, ({ data }) => {
    bus.invoke({
      type: BONUS_DEACTIVATE,
      payload: data
    })
  })

  bus.on(events.profile.bonusStatus, ({ data }) => {
    bus.invoke({
      type: BONUS_STATUS,
      payload: data
    })
  })

  bus.on(events.profile.bonusEligible, ({ data }) => {
    bus.invoke({
      type: BONUS_ELIGIBLE,
      payload: data
    })
  })

  bus.on(events.profile.betsCountUpdate, ({ data }) => {
    bus.invoke({
      type: BETS_COUNT_UPDATE,
      payload: data
    })
  })

  bus.on(events.profile.accountUpdate, payload => {
    bus.invoke({
      type: ACCOUNT_UPDATE,
      payload
    })
  })

  bus.on(events.profile.clientConfigChange, payload => {
    bus.emit(Bus.events.sport.sportReInit)
    bus.emit(Bus.events.racing.racingReInit)
  })

  bus.on(events.bespokeMarket.update, payload => {
    bus.invoke({
      type: BESPOKE_MARKET_UPDATE,
      payload
    })
  })

  /*
    Socket events handler
  */

  bus.on(events.socket.event, event => {
    // Looping socket events back to bus manager
    bus.emit(event.type, event.payload)
  })

  /*
  Layout events handler
  */
  bus.on(events.layout.setLayout, payload => {
    bus.invoke({
      type: SET_LAYOUT,
      payload
    })
  })

  bus.on(events.layout.setMobileDevice, payload => {
    bus.invoke({
      type: SET_MOBILE_DEVICE,
      payload
    })
  })

  bus.on(events.layout.setSideBarLeft, payload => {
    bus.invoke({
      type: SET_SIDEBAR_LEFT,
      payload
    })
  })

  bus.on(events.layout.setSideBarRight, payload => {
    bus.invoke({
      type: SET_SIDEBAR_RIGHT,
      payload
    })
  })

  bus.on(events.layout.setMainMenu, payload => {
    bus.invoke({
      type: SET_MAIN_MENU,
      payload
    })
  })

  bus.on(events.layout.setLiveChat, payload => {
    bus.invoke({
      type: SET_LIVE_CHAT,
      payload
    })
  })

  bus.on(events.betSlip.setBetSlip, payload => {
    bus.invoke({
      type: SET_BETSLIP,
      payload
    })
  })

  bus.on(events.betSlip.setMode, payload => {
    bus.invoke({
      type: SET_BETSLIP_MODE,
      payload
    })
  })
}
